import * as React from 'react';
import { NodeEvent } from '../../types/nodes';
import eventDateInfo from '../../helpers/eventDateInfo';
import IconList from '../IconList';

type Props = {
  event: NodeEvent;
};

const useEventTeaserDates = ({ field_date }: NodeEvent) => React.useMemo(() => {
  const { firstUpcomingDate, dates } = eventDateInfo(field_date);
  const hasMultipleDates = dates.length > 1;
  // Fall back to last date if no upcoming dates have been found.
  const teaserDate = firstUpcomingDate || dates[dates.length - 1];

  let startDate;
  let endDate;

  if (teaserDate) {
    startDate = new Date(teaserDate.start.date);
    endDate = new Date(teaserDate.end.date);
  }

  return { startDate, endDate, hasMultipleDates };
}, [field_date]);

const EventMetaData = (props: Props) => {
  const { event } = props;
  const address = event.field_location[0]?.entity.field_address[0];
  const { startDate, endDate } = useEventTeaserDates(event);

  return (
    <div className="text-large u-color-black">
      <IconList
        listItems={[
          {
            key: 'location',
            icon: 'location_on',
            text: `${address?.address_line1!}, ${address?.locality!}`,
          },
          {
            key: 'date',
            icon: 'calendar_month',
            text: `${new Date(startDate!).toLocaleDateString('nl-NL', { weekday: 'long' })} ${new Date(startDate!).toLocaleDateString('nl-NL', { day: 'numeric' })} ${new Date(startDate!).toLocaleDateString('nl-NL', { month: 'long' })}`,
          },
          {
            key: 'time',
            icon: 'schedule',
            text: `${new Date(startDate!).toLocaleTimeString('nl-NL', { timeStyle: 'short' })} - ${new Date(endDate!).toLocaleTimeString('nl-NL', { timeStyle: 'short' })}`,
          },
        ]}
      />
    </div>
  );
};

export default EventMetaData;
